import React, { useEffect, useState } from 'react'
import { Autocomplete, Box, Button, IconButton, TextField, Typography } from '@mui/material'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { fieldTemplateService } from '../../../services/fieldTemplateService'
import { toast } from 'react-toastify'
import DeleteIcon from '@mui/icons-material/Delete' // Import DeleteIcon if not already imported
import { FIELD_TYPES } from '../../../utility/constants'

const options = [
  {
    label: 'Accumulator Subfield',
    value: 'parent_table_accumulator_subfield_template_id',
  },
  {
    label: 'Group By SubField',
    value: 'parent_table_group_by_subfield_template_id',
  },
]

const AggregationTables = ({ field, activityTemplateId }) => {
  const { user } = useAuthContext()
  const [type, setType] = useState({})
  const [allParentTableSubfield, setAllParentTableSubfield] = useState([])
  const [subfieldData, setSubfieldData] = useState({})

  useEffect(() => {
    ;(async () => {
      if (user && activityTemplateId) {
        try {
          const allFieldResult = (
            await fieldTemplateService.getAllFieldsInActivity(user, activityTemplateId)
          ).data

          // finding the parent table's subfields
          const subfield = allFieldResult.find((it) => it.id === field.id)
          const tableField = allFieldResult.find((it) => it.id === subfield.table_field_template_id)
          const parentTableField = allFieldResult.find(
            (it) => it.id === tableField.aggregation_parent_table_field_template_id
          )

          const allParentTableSubfields = allFieldResult.filter(
            (it) => it.table_field_template_id === parentTableField?.id
          )
          setAllParentTableSubfield(allParentTableSubfields)

          // getting subfield data
          const aggregationTableSubfieldsData = (
            await fieldTemplateService.getAggregationTableData(user, field.id)
          ).data
          setSubfieldData(aggregationTableSubfieldsData[0])

          if (aggregationTableSubfieldsData[0].parent_table_accumulator_subfield_template_id) {
            setType(options[0])
          } else if (aggregationTableSubfieldsData[0].parent_table_group_by_subfield_template_id) {
            setType(options[1])
          }
        } catch (error) {
          toast.error('Error fetching aggregation table data')
        }
      }
    })()
  }, [user, activityTemplateId, field.id])

  const saveChanges = async () => {
    try {
      await fieldTemplateService.addAggregationTable(user, subfieldData)
      toast.success('Added successfully')
    } catch (error) {
      toast.error('Error while adding Aggregation tables')
    }
  }

  const filterFieldsByType = (typeValue, fields) => {
    if (typeValue === 'parent_table_accumulator_subfield_template_id') {
      return fields.filter(
        (field) =>
          field.data_structure === FIELD_TYPES.CURRENCY ||
          field.data_structure === FIELD_TYPES.NUMBER
      )
    } else if (typeValue === 'parent_table_group_by_subfield_template_id') {
      return fields.filter(
        (field) =>
          field.data_structure === FIELD_TYPES.LIST ||
          field.data_structure === FIELD_TYPES.LIST_MULTI
      )
    }
    return []
  }

  return (
    <Box>
      <Typography variant="p">Aggregation Tables</Typography>
      <div style={{ display: 'flex', columnGap: 8, marginTop: 12, alignItems: 'center' }}>
        <Autocomplete
          size="small"
          sx={{ width: 300 }}
          options={options}
          value={type}
          getOptionLabel={(it) => it?.label || ''}
          onChange={(_, v) => setType(v)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Type"
              variant="outlined"
              color="primary"
              fullWidth
            />
          )}
        />

        {type?.value && (
          <Autocomplete
            size="small"
            id="autocomplete-field"
            value={allParentTableSubfield.find((it) => it.id === subfieldData[type.value])}
            sx={{ width: 300 }}
            options={filterFieldsByType(type.value, allParentTableSubfield)}
            getOptionLabel={(option) => option.field_template_name}
            onChange={(_, newValue) => {
              setSubfieldData({
                ...subfieldData,
                [type.value]: newValue?.id || null,
              })
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Field"
                variant="outlined"
                color="primary"
                fullWidth
              />
            )}
          />
        )}
        {type?.value && (
          <IconButton
            onClick={() => {
              setType({})
              setSubfieldData({
                ...subfieldData,
                parent_table_group_by_subfield_template_id: null,
                parent_table_accumulator_subfield_template_id: null,
              })
            }}
          >
            <DeleteIcon size="small" />
          </IconButton>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          columnGap: 16,
          width: '100%',
          justifyContent: 'flex-end',
          marginTop: 16,
        }}
      >
        <Button color="primary" variant="contained" onClick={saveChanges}>
          Save Changes
        </Button>
      </div>
    </Box>
  )
}

export default AggregationTables
